<template>
  <div>
    <v-menu
      left
    >
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
        >
          <v-icon>more_vert</v-icon>
        </v-btn>
      </template>

      <v-list dense>
        <event-create-update-dialog
          v-if="!event.isArchived"
          :event="event"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              v-on="on"
              @click.stop=""
            >
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon
                    left
                    small
                  >
                    edit
                  </v-icon>
                  Edit
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </event-create-update-dialog>

        <event-item-create-update-dialog
          v-if="!event.isArchived"
          :event-id="event.id"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              v-on="on"
              @click.stop=""
            >
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon
                    left
                    small
                  >
                    add
                  </v-icon>
                  Add Event Item
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </event-item-create-update-dialog>

        <event-group-create-update-dialog
          v-if="!event.isArchived"
          :event-id="event.id"
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              v-on="on"
              @click.stop=""
            >
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon
                    left
                    small
                  >
                    add
                  </v-icon>
                  Add Group
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </event-group-create-update-dialog>

        <v-list-item
          v-if="event.isActive && !event.isArchived && type === 'event'"
          @click="onRunEvent"
        >
          <v-list-item-content>
            <v-list-item-title>
              <v-icon
                left
                small
              >
                directions_run
              </v-icon>
              Run
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="event.isActive && !event.isArchived"
          @click="pauseEvent"
        >
          <v-list-item-content>
            <v-list-item-title>
              <v-icon
                left
                small
              >
                pause
              </v-icon>
              Pause
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="!event.isActive && !event.isArchived"
          @click="resumeEvent"
        >
          <v-list-item-content>
            <v-list-item-title>
              <v-icon
                left
                small
              >
                play_arrow
              </v-icon>
              Resume
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="!event.isArchived && type === 'event'"
          @click.stop="confirmArchive = true"
        >
          <v-list-item-content>
            <v-list-item-title>
              <v-icon
                left
                small
                color="error"
              >
                archive
              </v-icon>

              <span class="error--text">Archive</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="event.isArchived"
          @click="unarchiveEvent"
        >
          <v-list-item-content>
            <v-list-item-title>
              <v-icon
                left
                small
              >
                unarchive
              </v-icon>
              Unarchive
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="type === 'complete_event'"
          :disabled="isDeleteDisabled"
          @click.stop="confirmDelete = true"
        >
          <v-list-item-content>
            <v-list-item-title>
              <v-icon
                :color="isDeleteDisabled ? '' : 'error'"
                :disabled="isDeleteDisabled"
                left
                small
              >
                delete
              </v-icon>

              <span :class="isDeleteDisabled ? '' : 'error--text'">Delete</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <confirm-action
      :model="confirmArchive"
      :color="'error'"
      :title="'Archive Event'"
      :description="'Are you sure you want to archive this event?<br /><br />It will no longer be triggered by any part of the system. Existing executions of this event will still be in active'"
      :action-text="'Archive'"
      @cancel="confirmArchive = false"
      @confirmed="onConfirmArchive"
    />

    <confirm-action
      :model="confirmDelete"
      :color="'error'"
      :title="'Delete Completion Event'"
      :description="'Are you sure you want to delete this completion event?'"
      :action-text="'Delete'"
      @cancel="confirmDelete = false"
      @confirmed="onConfirmDelete"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import EventCreateUpdateDialog from "../EventCreateUpdateDialog"
import EventItemCreateUpdateDialog from "../../EventItem/EventItemCreateUpdateDialog"
import EventGroupCreateUpdateDialog from "../../EventGroup/EventGroupCreateUpdateDialog"
import ConfirmAction from "../../Common/ConfirmAction"

export default {
  components: {
    EventGroupCreateUpdateDialog,
    EventCreateUpdateDialog,
    EventItemCreateUpdateDialog,
    ConfirmAction
  },
  props: {
    event: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      required: true,
    },
    numChildren: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      confirmArchive: false,
      confirmDelete: false
    }
  },
  computed: {
    isDeleteDisabled() {
      return this.numChildren > 0 || this.type !== 'complete_event'
    }
  },
  methods: {
    ...mapActions([ 'updateEvent', 'deleteCompleteEvent', 'runEvent' ]),
    async onRunEvent() {
      const payload = {
        id: this.event.id
      }
      await this.runEvent(payload)
    },
    async archiveEvent() {
      const payload = {
        id: this.event.id,
        isArchived: true
      }

      await this.updateEvent(payload)
    },
    async onConfirmArchive() {
      await this.archiveEvent()
      this.confirmArchive = false
    },
    async onConfirmDelete() {
      const payload = {
        id: this.event.id
      }
      await this.deleteCompleteEvent(payload)
      this.confirmDelete = false
    },
    async unarchiveEvent() {
      const payload = {
        id: this.event.id,
        isArchived: false
      }

      await this.updateEvent(payload)
    },
    async resumeEvent() {
      const payload = {
        id: this.event.id,
        isActive: true
      }

      await this.updateEvent(payload)
    },
    async pauseEvent() {
      const payload = {
        id: this.event.id,
        isActive: false
      }

      await this.updateEvent(payload)
    }
  }
}
</script>
